export default {
	'delete-journal': 'Yövmiye sil',
	'view-the-associated-invoice': 'İlgili faturayı görüntüle',
	'there-are-no-details': 'Hiçbir ayrıntı yok',
	'new-journal': 'Yeni yövmiye defteri'
}